import { HasNgrxForm } from '@app/common/ngrx-forms-extensions';
import { emailFormState } from '@app/common/email-form';
import { ModuleTokens } from './ticket-copy-list.constant';

export class TicketCopyListState implements HasNgrxForm {
  forms = {
    ...emailFormState(ModuleTokens.Name)()
  };
}
